/* @flow strict */

import queryString from 'query-string';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import Credentials from '/client/src/api/Credentials.js';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import { POST } from '/client/src/api';
import NProgressCustom from '/client/src/components/nProgress/';
import { validateInput } from '/client/src/utils/validateInput';
import { GetErrorValidation } from '../../utils/errorMessageValidation';
import SystemDialog from '../../components/dialogs/system';

type PropsType = {
  toggleAuthenticateStatus: () => void,
  location: {
    search: any
  }
};

const ConfirmEmail = (props: PropsType): React.Element<typeof React.Fragment> => {
  const values = queryString.parse(props.location.search);
  const email = values.email;
  const code = values.code;
  const [ name, setName ] = React.useState('');
  const [ pass, setPass ] = React.useState('');
  const nameValidationMessage = React.createRef();
  const passValidationMessage = React.createRef();
  const [errorData, setErrorData] = React.useState(null);
  const [showModal, setShowModal] = React.useState(false);

  const sendRequest = async (e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void): Promise<any> => {
    e.preventDefault();

    const isValidName = validateInput(nameValidationMessage.current, name);
    const isValidPass = validateInput(passValidationMessage.current, pass);

    if (isValidName && isValidPass) {
      try {
        setStatus('loading');

        const { success } = await POST('/api/v1/1/merchants/confirm_email', {
          email_address: email,
          email_confirmation_code: code,
          first_name: name,
          last_name: '',
          merchant_rep_email_address: '',
          password: pass,
          referral_merchant_id: ''
        });

        NProgressCustom(true);

        window.localStorage.setItem('isFirstSignIn', true);

        const { user, token } = await POST('/auth', {
          email,
          password: pass
        });

        setTimeout(async () => {
          Credentials.login(token, user);

          setStatus('success');
          NProgressCustom(false);

          props.toggleAuthenticateStatus(true);
        }, 1000);
      } catch (error) {
        setStatus('error');

        setErrorData(error.data);
        setShowModal(true);

        setTimeout(() => {
          setStatus('');
        }, 5000);
      }
    }
  };

  if (!email || !code) {
    return <Redirect to='/login' />;
  }

  return (
    <>
      <div className="form-box-container">
        <div className="form-box-message">
          <h3 className="auth-message-header">
            Last step!
          </h3>
          <div
            className="auth-message-desc"
          >
            Thank you for confirming your email. Let's partner to create great experiences.
          </div>
        </div>

        <form role="form">
          <div className="mt-4">
            <label htmlFor="email">Work email address</label>
            <div>
              <input
                className="form-control"
                type="email"
                title="This field is required."
                readOnly
                value={email}
                style={{
                  color: '#8c8c8c'
                }}
              />
            </div>
          </div>

          <div className="mt-4">
            <label htmlFor="name">Your name</label>
            <div ref={nameValidationMessage}>
              <input
                className="form-control validationElement"
                type="text"
                title="This field is required."
                id="name"
                value={name}
                onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                  nameValidationMessage.current.classList.remove('has-error');
                  nameValidationMessage.current
                    .querySelector('input')
                    .classList
                    .remove('validationElement');
                  setName(e.target.value);
                }}
              />
              <span
                className="validationMessage"
              >This field is required.</span>
            </div>
          </div>

          <div className="mt-4">
            <label htmlFor="password">Password</label>
            <div ref={passValidationMessage}>
              <input
                className="form-control validationElement"
                type="password"
                title="This field is required."
                id="password"
                value={pass}
                onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                  passValidationMessage.current.classList.remove('has-error');
                  passValidationMessage.current
                    .querySelector('input')
                    .classList
                    .remove('validationElement');
                  setPass(e.target.value);
                }}
              />
              <span
                className="validationMessage"
              >This field is required.</span>
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-xs-12 text-center progress-button-50">
              <BtnLoader
                label='Get Started'
                handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                  sendRequest(e, setStatus);
                }}
              />
            </div>
          </div>
        </form>
      </div>
      {showModal &&
        <SystemDialog
          type={'error'}
          title={'Error!'}
          handleShow={setShowModal}
          content={
          <GetErrorValidation data={errorData} />}
        />
      }
    </>
  );
};

export default ConfirmEmail;
